<div class="flex h-screen overflow-hidden">
  @if (drawerOpen()) {
    <button
      type="button"
      class="sidebar-mobile-backdrop"
      aria-label="Close menu"
      (click)="drawerOpen.set(false)"
    ></button>
  }

  <div class="sidebar-drawer-wrapper" [class.drawer-open]="drawerOpen()">
    <app-sidebar
      [isMobile]="isMobile()"
      [collapsed]="sidebarCollapsed()"
      (closeDrawer)="drawerOpen.set(false)"
      (toggleCollapse)="toggleSidebarCollapse()"
    />
  </div>

  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    <app-tab-bar (toggleDrawer)="drawerOpen.set(!drawerOpen())" />
    <main class="flex-1 overflow-y-auto overflow-x-hidden app-page-bg">
      <router-outlet />
    </main>
  </div>
</div>
